
export const getInternetStatus = async () => {
  const online = navigator.onLine;
  
  let tone = 'ok';
  let value = 'Connected';
  
  if (!online) {
    tone = 'error';
    value = 'Offline';
  } else {
    try {
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      
      if (connection) {
        const effectiveType = connection.effectiveType || 'unknown';
        const downlink = connection.downlink || 0;
        
        if (effectiveType === 'slow-2g' || effectiveType === '2g') {
          tone = 'error';
          value = 'Slow';
        } else if (effectiveType === '3g' || downlink < 1.5) {
          tone = 'warning';
          value = 'Slow';
        } else {
          tone = 'ok';
          value = 'Connected';
        }
      }
    } catch (error) {
      // If connection API fails, just use online status
      tone = online ? 'ok' : 'error';
      value = online ? 'Connected' : 'Offline';
    }
  }
  
  return {
    online,
    tone,
    value,
  };
};


export const monitorInternetStatus = (callback) => {
  const updateStatus = async () => {
    const status = await getInternetStatus();
    callback(status);
  };
  
  // Set up event listeners
  const onlineListener = () => updateStatus();
  const offlineListener = () => updateStatus();
  
  window.addEventListener('online', onlineListener);
  window.addEventListener('offline', offlineListener);
  
  // Also monitor connection changes if available
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  let connectionListener = null;
  
  if (connection) {
    connectionListener = () => updateStatus();
    connection.addEventListener('change', connectionListener);
  }
  
  // Initial update
  updateStatus();
  
  // Return cleanup function
  return () => {
    window.removeEventListener('online', onlineListener);
    window.removeEventListener('offline', offlineListener);
    if (connection && connectionListener) {
      connection.removeEventListener('change', connectionListener);
    }
  };
};



